// extracted by mini-css-extract-plugin
export default {"root":"LoanStatusPage_root__+ZvDc","section":"LoanStatusPage_section__S+b4X","documentContainer":"LoanStatusPage_documentContainer__8Q1kp"};